// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__SVpzC","label":"Category_label__11Luq","content":"Category_content__1_0yT","header":"Category_header__y916o","location":"Category_location__14BNr"};